/** Homepage-style export copy, with entity names swapped for AI Hub lists. */

export const TAGGING_RESULT_EXPORT_COPY = {
  emptyTooltip: "Select Classification results in the table before exporting.",
  selectedTooltip: "Export selected Classification results.",
  failureMessage: "Export failed. Please try again.",
} as const;

export const ENHANCED_TAGGING_RESULT_EXPORT_COPY = {
  emptyTooltip:
    "Select Conditional Classification results in the table before exporting.",
  selectedTooltip: "Export selected Conditional Classification results.",
  failureMessage: "Export failed. Please try again.",
} as const;
